"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var events_1 = require("../events");
var Action = (function (_super) {
    tslib_1.__extends(Action, _super);
    function Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Action.prototype.run = function (data) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results, execution, termination, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.data = data;
                        results = undefined;
                        execution = this.execute(this.data);
                        termination = new Promise(function (resolve, reject) {
                            _this._resolve = resolve;
                            _this._reject = reject;
                        });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, Promise.race([execution, termination])];
                    case 2:
                        results = _c.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _c.sent();
                        if (this.onFailed) {
                            (_a = this.onFailed) === null || _a === void 0 ? void 0 : _a.call(null);
                        }
                        else {
                            throw e_1;
                        }
                        return [3, 4];
                    case 4:
                        (_b = this.onFinish) === null || _b === void 0 ? void 0 : _b.call(null);
                        return [2, results];
                }
            });
        });
    };
    Action.prototype.terminate = function (reason) {
        var _a;
        (_a = this._reject) === null || _a === void 0 ? void 0 : _a.call(null, reason);
    };
    Action.prototype.destroy = function () {
        delete this.data;
        delete this._resolve;
        delete this._reject;
        delete this.onFinish;
        delete this.onFailed;
    };
    Action = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], Action);
    return Action;
}(events_1.GlobalEventProvider));
exports.Action = Action;
//# sourceMappingURL=Action.js.map